import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  ReportFilterFieldService
} from '../../../../services/report/report-filter/report-filter-field/report-filter-field.service';
import {ComboBoxOption} from '../../../../models/combo-box-option';

@Component({
  selector: 'app-report-filter-report001',
  templateUrl: './report-filter-report001.component.html',
  styleUrls: ['./report-filter-report001.component.scss']
})
export class ReportFilterReport001Component implements OnInit {

  filters: any = {};
  comboOptions: any;
  isLoadingComboOptions: boolean = false;
  inventoryOptions: ComboBoxOption[] = ReportFilterFieldService.INVENTORY_OPTIONS;

  constructor() {
  }

  ngOnInit(): void {
  }

  // Attribute: data

  @Output()
  dataChange = new EventEmitter<any>();

  @Input()
  get data() {
    return this.filters;
  }

  set data(value) {
    this.filters = value;
    this.dataChange.emit(this.filters);
  }

  // Attribute: options

  @Output()
  optionsChange = new EventEmitter<any>();

  @Input()
  get options() {
    return this.comboOptions;
  }

  set options(value: any) {
    this.comboOptions = value;
    this.optionsChange.emit(this.comboOptions);
  }

  // Attribute: loading

  @Output()
  loadingChange = new EventEmitter<boolean>();

  @Input()
  get loading() {
    return this.isLoadingComboOptions;
  }

  set loading(value) {
    this.isLoadingComboOptions = value;
    this.loadingChange.emit(this.isLoadingComboOptions);
  }

}
